import { XClose } from '@untitled-ui/icons-react';
import { type ReactNode } from 'react';

import { tGlobal } from '../services/translation';
import { IconButton } from './buttons/icon-button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from './dialog';

export type FieldsDialogProps = {
  open: boolean;
  onOpenChange: (val: boolean) => unknown;
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
};

export function FieldsDialog(props: FieldsDialogProps) {
  const { open, onOpenChange, title, description, children, className = '' } = props;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={className}
        aria-describedby={undefined}
        onPointerDownOutside={function (event) {
          event.preventDefault();
        }}
        onEscapeKeyDown={function () {
          props.onOpenChange(false);
        }}
      >
        <div>
          <IconButton
            className="absolute right-3 top-3"
            variant="outline-circular"
            icon={XClose}
            onClick={function () {
              props.onOpenChange(false);
            }}
            aria-label={tGlobal('close')}
            tabIndex={-1}
          />
          <DialogTitle>
            <p className="text-v1-slate12 mb-8 font-body text-2xl font-bold">{title}</p>
          </DialogTitle>
          {description !== undefined ? <DialogDescription>{description}</DialogDescription> : null}
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
}
